"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterProduct = void 0;
const tslib_1 = require("tslib");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class RegisterProduct extends base_models_1.Serializable {
}
exports.RegisterProduct = RegisterProduct;
tslib_1.__decorate([
    (0, class_transformer_1.Expose)({ name: 'identifier' }),
    (0, base_models_1.Docs)({
        description: 'public identifier for card or charging station',
        example: 'NL-ESS-A0000012345-Z',
    }),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    tslib_1.__metadata("design:type", String)
], RegisterProduct.prototype, "identifier", void 0);
